import {weChatrequest} from '@/utils/request'

// 查询登录日志列表
export function loginLogList(query) {
  return weChatrequest({
    url: '/api/v1/logininfo/page',
    method: 'get',
    params: query
  })
}
// 导出登录日志
export function exportLoginLog(data) {
  return weChatrequest({
    url: '/api/v1/logininfo/export',
    method: 'post',
    responseType: 'blob',
    data: data
  })
}

// 查询租户详细

export function getTenant(id) {
  return weChatrequest({
    url: `/api/v1/tenants/${id}`,
    method: 'get'
  })
}



// 删除登录日志
export function delLogininfo(id) {
  return weChatrequest({
    url: `/api/v1/logininfo/${id}`,
    method: 'DELETE'
  })
}

// 清空登录日志
export function cleanLogininfo() {
  return weChatrequest({
    url: `/api/v1/logininfo/clean`,
    method: 'DELETE'
  })
}

// 查询操作日志列表
export function operlogLogList(query) {
  return weChatrequest({
    url: '/api/v1/operlog/page',
    method: 'get',
    params: query
  })
}

// 导出操作日志
export function operlogLoginLog(data) {
  return weChatrequest({
    url: '/api/v1/operlog/export',
    method: 'post',
    responseType: 'blob',
    data: data
  })
}
// 删除操作日志
export function delOperlog(id) {
  return weChatrequest({
    url: `/api/v1/operlog/${id}`,
    method: 'DELETE'
  })
}

// 清空操作日志
export function cleanOperlog() {
  return weChatrequest({
    url: `/api/v1/operlog/clean`,
    method: 'DELETE'
  })
}

